export const JobOpportunityStatus = [
  "DRAFT",
  "NEW",
  "OPEN",
  "APPLYING",
  "INTERVIEWING",
  "HIRING",
  "HIRED",
  "CLOSED",
  "PAUSED",
  "FILLED",
  "EXPIRED",
  "CANCELLED",
  "DELETED",
];

export const JobOpportunityLocationType = ["REMOTE", "ONSITE", "HYBRID"];

export const JobOpportunityWorkSchedule = [
  "PART_TIME",
  "FULL_TIME",
  "SHIFT",
  "FEW_HOURS",
  "FEW_DAYS",
  "ONE_DAY",
  "FLEXIBLE",
  "CONTRACT",
  "TEMPORARY",
  "ANY",
];

export const JobOpportunityPosterType = ["USER", "BUSINESS", "BUSINESS_ENTITY"];

export const UserEducationLevel = [
  "NONE",
  "HIGH_SCHOOL",
  "GED",
  "CERTIFICATE",
  "ASSOCIATE",
  "BACHELOR",
  "MASTER",
  "DOCTORATE",
  "OTHER",
];

